import React, { useContext, useState, useRef, useEffect } from "react";
import SidebarMenu from "../shared/SidebarMenu";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import { getBranding } from "@Branding";
import { ArrowCircleDown } from "@mui/icons-material";
import { Tooltip } from "antd";

interface IProps {
    skeleton?: boolean;
}

const Sidebar: React.FC<IProps> = ({ skeleton }: IProps) => {
    const { settingMode } = useContext(MainContext);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const sidebarRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            if (sidebarRef.current.scrollHeight > sidebarRef.current.clientHeight) {
                setIsOverflowing(true);
            } else {
                setIsOverflowing(false);
            }
        });

        resizeObserver.observe(sidebarRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    const settingCurrentMode = (width) => {
        // TABLET VIEW
        if (width <= 1100 && width >= 750) {
            settingMode(ViewMode.tablet);
        } else {
            // DESKTOP VIEW
            if (width > 1100) {
                settingMode(ViewMode.desktop);
            }
            // MOBILE VIEW
            if (width < 750) {
                settingMode(ViewMode.mobile);
            }
        }
    };

    const handleResizeViewport = (e) => {
        const currentWidth = e.target.innerWidth;
        settingCurrentMode(currentWidth);
    };
    window.addEventListener("resize", handleResizeViewport);
    useEffect(() => {
        const currentWidth = window.innerWidth;
        settingCurrentMode(currentWidth);
    }, []);

    return (
        <div
            suppressHydrationWarning={true}
            style={{ backgroundColor: getBranding("--sidebar-background") }}
            className="sider"
            ref={sidebarRef}
        >
            {isOverflowing ? (
                <Tooltip title="scroll down for more options">
                    <ArrowCircleDown className="arrow-circle-down" />
                </Tooltip>
            ) : null}
            <SidebarMenu skeleton={skeleton} key={"sidebar-menu-root"} />
        </div>
    );
};

export default Sidebar;
